import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Consumer as WallectClientConsumer } from '../context/WalletConnectProvider'
import Modal from '../../components/common/Modal'
import QRCode from '../../components/common/QRCode'

import { setWalletConnectURI } from '../../redux/walletConnect/action'
import { withI18n } from '../../i18n/util'

const ModalBody = styled.div`
  color: inherit;
  text-align: center;
  width: 360px;
  margin-top: 20px;
  p {
    color: ${({ theme }) => theme.thColor};
    margin-top: 20px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`

class WalletConnectModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    wcUri: PropTypes.string,
    formatI18nText: PropTypes.func.isRequired,
  }

  static defaultProps = {
    wcUri: '',
  }

  _onModalClosed = walletConnectClient => {
    const { dispatch } = this.props
    console.log('close WalletConnect qrcode modal')
    walletConnectClient.connected && walletConnectClient.disconnect()
    dispatch(setWalletConnectURI(''))
  }

  render() {
    const { wcUri, formatI18nText } = this.props
    if (!wcUri) return null

    return (
      <WallectClientConsumer>
        {wcClient => (
          <Modal
            close={() => {
              this._onModalClosed(wcClient)
            }}
            title={formatI18nText('walletConnect.qrCode')}
            hideButton={true}
          >
            <ModalBody>
              <QRCode value={wcUri} size={200} padding={15} />
              <p>{formatI18nText('walletConnect.pleaseUseAWalletConnect')}</p>
            </ModalBody>
          </Modal>
        )}
      </WallectClientConsumer>
    )
  }
}

const mapStateToProps = ({ walletConnect: { wcUri } }) => ({
  wcUri,
})

export default withI18n(connect(mapStateToProps)(WalletConnectModal))
